// stores/twScreens.js
import { browser } from '$app/environment';
import { twScreens } from '$lib/tailwindThemeHelper';
import debounce from 'lodash.debounce';
import { getContext, setContext } from 'svelte';
import { readable, type Readable } from 'svelte/store';

interface BreakpointsReadableStore {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isTabletUp: boolean;
  isTabletDown: boolean;
}

export function createBreakpointsStore() {
  const store = readable<BreakpointsReadableStore>(
    {
      isMobile: false,
      isTablet: false,
      isDesktop: false,
      isTabletUp: false,
      isTabletDown: false
    },
    (set) => {
      function updateBreakpoints() {
        const isMobile = window.matchMedia(`(max-width: ${twScreens.md})`).matches;
        const isTablet = window.matchMedia(
          `(min-width: ${twScreens.md}) and (max-width: ${twScreens.lg})`
        ).matches;
        const isDesktop = window.matchMedia(`(min-width: ${twScreens.lg})`).matches;

        const isTabletUp = window.matchMedia(`(min-width: ${twScreens.md})`).matches;
        const isTabletDown = window.matchMedia(`(max-width: ${twScreens.lg})`).matches;

        set({ isMobile, isTablet, isDesktop, isTabletUp, isTabletDown });
      }

      if (browser) {
        // Initial check
        updateBreakpoints();

        const debouncedUpdateBreakpoints = debounce(updateBreakpoints, 100);
        window.addEventListener('resize', debouncedUpdateBreakpoints);

        // Cleanup on unmount
        return () => {
          window.removeEventListener('resize', debouncedUpdateBreakpoints);
        };
      }
    }
  );

  setContext('breakpointsContextStore', store);
}

export function readBreakpointsStore() {
  return getContext<Readable<BreakpointsReadableStore>>('breakpointsContextStore');
}
